import React from 'react';
import PropTypes from 'prop-types';
import {
  arrayBuilderYesNoUI,
  arrayBuilderYesNoSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { STR_QUESTION_PATH, serviceTreatmentRecordsOptions } from './options';

/**
 * Override the platform behavior when the last file is deleted on the loop
 * summary: instead of forcing the item page in add mode with a warning
 * (`…?add=true&removedAllWarn=true`), return to the entry page so the
 * Veteran can upload again or choose to submit later.
 */
export const strSummaryGoToPath = goToPath => (path, options) => {
  if (path?.includes('removedAllWarn=true')) {
    goToPath(`/${STR_QUESTION_PATH}`, { force: true });
    return;
  }
  goToPath(path, options);
};

/** Wraps the platform summary `CustomPage` with the last-delete routing above. */
export const withLastDeleteRouting = DefaultSummaryPage => {
  const SummaryPageWithLastDeleteRouting = props => (
    <DefaultSummaryPage
      {...props}
      goToPath={strSummaryGoToPath(props.goToPath)}
    />
  );
  SummaryPageWithLastDeleteRouting.propTypes = {
    goToPath: PropTypes.func,
  };
  return SummaryPageWithLastDeleteRouting;
};

/** Review (loop summary) page. The yes/no question renders as a regular
 * label (not the array builder's default heading), per the design. */
export default {
  uiSchema: {
    'view:hasAnotherServiceTreatmentRecord': arrayBuilderYesNoUI(
      serviceTreatmentRecordsOptions,
      {
        title: 'Do you have service treatment records to add?',
        labels: { Y: 'Yes', N: 'No' },
        labelHeaderLevel: '',
      },
      {
        title: 'Do you have other service treatment records to add?',
        labels: { Y: 'Yes', N: 'No' },
        labelHeaderLevel: '',
      },
    ),
  },
  schema: {
    type: 'object',
    properties: {
      'view:hasAnotherServiceTreatmentRecord': arrayBuilderYesNoSchema,
    },
    required: ['view:hasAnotherServiceTreatmentRecord'],
  },
};
